module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/088-uruguay-9981506fc811447595bfe77d7545c221.svg";